/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Порядок сортировки адреса в отчете ФТР. вообще не нужный класс, но они до сих пор не уверены в сортировке.
 */
export interface VisibilityOptionsView { 
    /**
     * Код.
     */
    codeName: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
}

